// import _ from 'lodash';
import moment from 'moment';
import { timeAndPrecisionTypes } from 'smartsuite-ui';
import {
    // predicateValues,
    // viewConfigurationDefaults,
    // widgetConfigurationDefaults,
    dateFormat,
    // dateTimeFormat,
    // precisionTypes,
    // standardPredefinedDateRanges,
} from '../shared/constants/constants';
// import { initializeWidgetMetricRequests } from './metricRequestUtils';
// import { numberDecimalFormatters } from '../dashboardUtils';
// import { getSmallestPrecisionTypeAndPrecisionValue } from '../../shared/filtering/timeAndPrecisionValidation';
// import { getIsFixedRangeInOrder } from '../../shared/filtering/filtersModalUtils';

// eslint-disable-next-line complexity
export function sanitizeTimeRange(timeRange, predefinedDateRanges) {
    const timeRangeValue = timeRange ?? {};
    const predefinedDateRangesValue = predefinedDateRanges ?? [];
    const sanitizedTimeRange = { ...timeRangeValue };

    sanitizedTimeRange.selectedDateRangeOption =
        predefinedDateRangesValue.find(
            (dateRange) => dateRange.name === timeRange.predefinedDateRange
        ) ?? predefinedDateRangesValue[0];

    /* eslint-disable indent */
    sanitizedTimeRange.endDateTime =
        timeRangeValue.timeRangeType === timeAndPrecisionTypes.fixedDay
            ? moment(timeRangeValue.startDateTime)
                  .startOf('day')
                  .add(1, 'day')
                  .format(dateFormat)
            : timeRangeValue.endDateTime;
    /* eslint-enable indent */

    return {
        ...sanitizedTimeRange,
        ...sanitizedTimeRange.selectedDateRangeOption,
    };
}

// export function getDefaultedTimeAndPrecision(
//     timeAndPrecision,
//     predefinedDateRanges,
//     precisionTypeOptions
// ) {
//     const timeAndPrecisionValue = timeAndPrecision ?? {};
//     const predefinedDateRangesValue = predefinedDateRanges ?? [];
//     const now = moment();

//     const withDefaults = {
//         timeAndPrecisionType: timeAndPrecisionTypes.last,
//         startDateTime: now.startOf('day').format(dateTimeFormat),
//         endDateTime: now.startOf('day').add(1, 'day').format(dateTimeFormat),
//         rangeType: precisionTypes.day,
//         rangeValue: 1,
//         ...timeAndPrecisionValue,
//     };

//     const sanitizedTimeAndPrecision = sanitizeTimeAndPrecision(
//         withDefaults,
//         predefinedDateRangesValue,
//         precisionTypeOptions
//     );

//     return sanitizedTimeAndPrecision;
// }

// export function defaultUserDashboardConfig() {
//     return {
//         timeAndPrecision: getDefaultedTimeAndPrecision(),
//         widgets: [],
//     };
// }

// export function timeAndPrecisionTypeIsDifferent(
//     timeAndPrecision,
//     updatedTimeAndPrecision
// ) {
//     return (
//         timeAndPrecision.timeAndPrecisionType !==
//         updatedTimeAndPrecision.timeAndPrecisionType
//     );
// }

// export function rangeTypeIsDifferent(
//     timeAndPrecision,
//     updatedTimeAndPrecision
// ) {
//     return timeAndPrecision.timeAndPrecisionType === 'predefined'
//         ? timeAndPrecision.selectedDateRangeOption?.predefinedType !==
//               updatedTimeAndPrecision.selectedDateRangeOption?.predefinedType
//         : timeAndPrecision.rangeType !== updatedTimeAndPrecision.rangeType;
// }

// export function fixedDateIsValidAndDifferent(
//     timeAndPrecision,
//     updatedTimeAndPrecision
// ) {
//     return (
//         getIsFixedRangeInOrder(updatedTimeAndPrecision) &&
//         (!moment(timeAndPrecision.startDateTime).isSame(
//             updatedTimeAndPrecision.startDateTime
//         ) ||
//             !moment(timeAndPrecision.endDateTime).isSame(
//                 updatedTimeAndPrecision.endDateTime
//             ))
//     );
// }

// /* eslint-disable complexity */
// export function getAndValidateTimeAndPrecision(
//     timeAndPrecision,
//     timeAndPrecisionTypeOptions,
//     predefinedDateRanges,
//     isWidget = true
// ) {
//     if (
//         isWidget &&
//         (timeAndPrecisionTypeOptions || predefinedDateRanges?.length > 0) &&
//         _.isEmpty(timeAndPrecision)
//     ) {
//         throw Error(
//             // eslint-disable-next-line max-len
//             'Widget timeAndPrecision must be configured when specifying either timeAndPrecisionOptions, or predefinedDateRanges'
//         );
//     }

//     if (
//         timeAndPrecisionTypeOptions &&
//         !timeAndPrecisionTypeOptions.includes(
//             timeAndPrecision.timeAndPrecisionType
//         )
//     ) {
//         throw Error(
//             'TimeAndPrecisionType not in configured timeAndPrecisionTypeOptions'
//         );
//     }

//     if (
//         timeAndPrecisionTypeOptions &&
//         timeAndPrecisionTypeOptions.includes('predefined') &&
//         predefinedDateRanges.length === 0
//     ) {
//         throw Error(
//             'Predefined is an option, but PredefinedDateRanges are not configured'
//         );
//     }

//     if (
//         timeAndPrecision.timeAndPrecisionType ===
//             timeAndPrecisionTypes.predefined &&
//         predefinedDateRanges.length > 0 &&
//         !predefinedDateRanges.find(
//             (dateRange) =>
//                 dateRange.name === timeAndPrecision.predefinedDateRange
//         )
//     ) {
//         throw Error(
//             'PredefinedDateRange not in configured predefinedDateRanges'
//         );
//     }

//     return timeAndPrecision;
// }
// /* eslint-enable complexity */

// export function getNumberDecimalFormatter(
//     formatterKey,
//     defaultNumberDecimalFormatter = numberDecimalFormatters.noDecimal
// ) {
//     if (!formatterKey) {
//         return defaultNumberDecimalFormatter;
//     }

//     if (!Object.keys(numberDecimalFormatters).includes(formatterKey)) {
//         throw Error('NumberDecimalFormatterKey does not exist');
//     }

//     return numberDecimalFormatters[formatterKey];
// }

// export function isSubset(subArray, overallArray) {
//     return subArray.every((subItem) => overallArray.includes(subItem));
// }

// function areRequiredFiltersInValid(requiredFilterKeys, availableFilterKeys) {
//     return (
//         !_.isEmpty(requiredFilterKeys) &&
//         (_.isEmpty(availableFilterKeys) ||
//             !isSubset(requiredFilterKeys, availableFilterKeys))
//     );
// }

// export function getAvailableFilters(
//     filterConfigurations,
//     availableFilterKeys,
//     requiredFilterKeys
// ) {
//     if (areRequiredFiltersInValid(requiredFilterKeys, availableFilterKeys)) {
//         throw Error(
//             'Required filters specified, but no available filters configured'
//         );
//     }

//     if (_.isEmpty(availableFilterKeys)) {
//         return {};
//     }

//     /* eslint-disable no-param-reassign */
//     return availableFilterKeys.reduce((result, filterKey) => {
//         if (!filterConfigurations[filterKey]) {
//             throw Error(`No filter configuration specified for: ${filterKey}`);
//         }

//         result[filterKey] = {
//             ...filterConfigurations[filterKey],
//             cascadeChildKey: _.findKey(
//                 filterConfigurations,
//                 (filterConfig) => filterConfig.cascadeParentKey === filterKey
//             ),
//         };
//         return result;
//     }, {});
//     /* eslint-enable no-param-reassign */
// }

// export function mergeDrawConfigWithOverrides(
//     widgetRenderers,
//     configurationKey,
//     overrides
// ) {
//     return _.merge({}, widgetRenderers[configurationKey], overrides);
// }

// function getMultiChartConfiguration(
//     widgetRenderers,
//     widgetConfiguration,
//     drawConfigurationOverrides
// ) {
//     if (!Object.keys(widgetRenderers).includes(widgetConfiguration.chartType)) {
//         throw Error(
//             `Multi chart chart type <${widgetConfiguration.chartType}> does not exist`
//         );
//     }

//     return mergeDrawConfigWithOverrides(
//         widgetRenderers,
//         widgetConfiguration.chartType,
//         drawConfigurationOverrides
//     );
// }

// export function getWidgetConfiguration(
//     widgetRenderers,
//     { configurationKey, drawConfigurationOverrides = {} }
// ) {
//     if (!Object.keys(widgetRenderers).includes(configurationKey)) {
//         throw Error(
//             `Widget configurationKey <${configurationKey}> does not exist`
//         );
//     }

//     const widgetConfiguration = mergeDrawConfigWithOverrides(
//         widgetRenderers,
//         configurationKey,
//         drawConfigurationOverrides
//     );

//     if (configurationKey === 'multiChart') {
//         widgetConfiguration.chartTypeConfiguration = getMultiChartConfiguration(
//             widgetRenderers,
//             widgetConfiguration,
//             drawConfigurationOverrides
//         );
//     }

//     return widgetConfiguration;
// }

// /* eslint-disable complexity */
// function getThresholdKeyParameterizedId(thresholdKey, filterValues) {
//     const filterTokensInKey = (thresholdKey.match(/{.+}/g) || []).map((x) =>
//         x.replace(/[{}]/g, '')
//     );

//     let thresholdKeyWithFilterValues = thresholdKey;
//     filterTokensInKey.forEach((token) => {
//         const filterValueForToken = filterValues[token];
//         if (
//             _.isEmpty(filterValueForToken) ||
//             _.isEmpty(filterValueForToken.values) ||
//             filterValueForToken.predicate.valueField !== predicateValues.isIn
//         ) {
//             // eslint-disable-next-line no-console
//             console.log(
//                 `No filter selected for token: {${token}} in threshold key: ${thresholdKey}`
//             );
//             return;
//         }

//         thresholdKeyWithFilterValues = thresholdKeyWithFilterValues.replace(
//             token,
//             filterValueForToken.values[0].valueField
//         );
//     });

//     return thresholdKeyWithFilterValues.replace(/[{}]/g, '');
// }
// /* eslint-enable complexity */

// function selectedFilterMatchesThresholdItem(
//     thresholdValues,
//     thresholdId,
//     selectedFilterValue
// ) {
//     const systemThreshold = thresholdValues.find(
//         (x) =>
//             x.id === thresholdId &&
//             (x.itemId === null || x.itemId === undefined)
//     );

//     const itemThreshold = thresholdValues.find(
//         (x) => x.id === thresholdId && x.itemId === selectedFilterValue
//     );

//     return itemThreshold ?? systemThreshold;
// }

// export function getThresholdsWithValues(
//     thresholdConfigs,
//     thresholdValues,
//     filterValues
// ) {
//     if (_.isEmpty(thresholdConfigs)) {
//         return [];
//     }

//     if (_.isEmpty(thresholdValues)) {
//         return thresholdConfigs;
//     }

//     return thresholdConfigs.reduce((result, thresholdConfig) => {
//         const thresholdId = getThresholdKeyParameterizedId(
//             thresholdConfig.id,
//             filterValues
//         );

//         if (thresholdConfig.filterKey) {
//             const selectedFilterValue =
//                 filterValues[thresholdConfig.filterKey]?.values?.[0]
//                     ?.valueField;

//             const threshold = selectedFilterMatchesThresholdItem(
//                 thresholdValues,
//                 thresholdId,
//                 selectedFilterValue
//             );

//             result.push({
//                 ...thresholdConfig,
//                 value: threshold?.value,
//             });

//             return result;
//         }

//         const thresholdsForConfig = thresholdValues.filter(
//             (x) => x.id === thresholdId
//         );

//         if (_.isEmpty(thresholdsForConfig)) {
//             result.push(thresholdConfig);
//         }

//         thresholdsForConfig.forEach((x) =>
//             result.push({
//                 ...thresholdConfig,
//                 itemId: x.itemId,
//                 value: x.value,
//             })
//         );

//         return result;
//     }, []);
// }

// export function isWidgetThresholdOnly(metricRequests) {
//     return _.isEmpty(metricRequests);
// }

// export function getWidgetTimeAndPrecision(timeAndPrecision = {}) {
//     const value = { ...timeAndPrecision };

//     if (value.timeAndPrecisionType === timeAndPrecisionTypes.fixedDay) {
//         value.endDateTime = moment(value.startDateTime)
//             .startOf('day')
//             .add(1, 'days')
//             .format(dateFormat);
//     }

//     return value;
// }

// /* eslint-disable complexity */
// export function setupWidgetConfiguration(
//     widgetRenderers,
//     widget,
//     defaultNumberDecimalFormatter,
//     filterConfigurations
// ) {
//     const defaultedWidgetConfig = {
//         ...widgetConfigurationDefaults(),
//         ...widget,
//     };

//     const availableFilters = getAvailableFilters(
//         filterConfigurations,
//         defaultedWidgetConfig.availableFilterKeys,
//         defaultedWidgetConfig.requiredFilterKeys
//     );

//     const drawConfiguration = getWidgetConfiguration(
//         widgetRenderers,
//         defaultedWidgetConfig
//     );

//     const numberDecimalFormatter = getNumberDecimalFormatter(
//         defaultedWidgetConfig.numberDecimalFormatterKey,
//         defaultNumberDecimalFormatter
//     );

//     const timeAndPrecision = getAndValidateTimeAndPrecision(
//         getWidgetTimeAndPrecision(defaultedWidgetConfig.timeAndPrecision),
//         defaultedWidgetConfig.timeAndPrecisionTypeOptions,
//         defaultedWidgetConfig.predefinedDateRanges
//     );

//     const metricRequests = initializeWidgetMetricRequests(
//         defaultedWidgetConfig.metricRequests
//     );

//     const isGauge = !_.isEmpty(metricRequests)
//         ? !!metricRequests[0].isGaugeMetric
//         : false;

//     return {
//         ...defaultedWidgetConfig,
//         availableFilters,
//         configuration: drawConfiguration,
//         isGauge,
//         metricRequests,
//         numberDecimalFormatter,
//         timeAndPrecision,
//     };
// }
// /* eslint-enable complexity */

// export function setupCustomDashboardConfiguration(
//     widgetRenderers,
//     configuration
// ) {
//     const timeAndPrecision = getDefaultedTimeAndPrecision(
//         configuration.timeAndPrecision,
//         standardPredefinedDateRanges
//     );

//     const widgets = configuration.widgets.map((widget) => {
//         const drawConfiguration = getWidgetConfiguration(
//             widgetRenderers,
//             widget.staticData
//         );
//         const numberDecimalFormatter = getNumberDecimalFormatter(
//             widget.staticData.numberDecimalFormatterKey,
//             widget.staticData.defaultNumberDecimalFormatter
//         );

//         return {
//             ...widget.staticData,
//             ...widget.stateData,
//             id: widget.id,
//             configuration: drawConfiguration,
//             numberDecimalFormatter,
//         };
//     });

//     return {
//         ...configuration,
//         timeAndPrecision,
//         widgets,
//     };
// }

// export function setupViewAndWidgetConfigurations(
//     widgetRenderers,
//     viewConfiguration
// ) {
//     if (viewConfiguration.viewKey === undefined) {
//         throw Error('Views are required to have a viewKey');
//     }

//     const defaultedConfiguration = {
//         ...viewConfigurationDefaults,
//         ...viewConfiguration,
//     };

//     const availableFilters = getAvailableFilters(
//         defaultedConfiguration.filterConfigurations,
//         defaultedConfiguration.availableFilterKeys,
//         defaultedConfiguration.requiredFilterKeys
//     );

//     const defaultNumberDecimalFormatter = getNumberDecimalFormatter(
//         defaultedConfiguration.defaultNumberDecimalFormatterKey
//     );

//     const timeAndPrecision = getAndValidateTimeAndPrecision(
//         getDefaultedTimeAndPrecision(
//             defaultedConfiguration.timeAndPrecision,
//             defaultedConfiguration.predefinedDateRanges
//         ),
//         defaultedConfiguration.timeAndPrecisionTypeOptions,
//         defaultedConfiguration.predefinedDateRanges,
//         false
//     );

//     const widgets = defaultedConfiguration.widgets.map((widget) =>
//         setupWidgetConfiguration(
//             widgetRenderers,
//             widget,
//             defaultNumberDecimalFormatter,
//             defaultedConfiguration.filterConfigurations
//         )
//     );

//     return {
//         ...defaultedConfiguration,
//         availableFilters,
//         defaultNumberDecimalFormatter,
//         timeAndPrecision,
//         widgets,
//     };
// }

// export function getUpdatedWidget(
//     currentWidget,
//     updatedTimeAndPrecision,
//     updatedFilters,
//     updatedWhereClauses,
//     updatedRecordLimit
// ) {
//     return {
//         ...currentWidget,
//         filterValues: updatedFilters,
//         timeAndPrecision: updatedTimeAndPrecision,
//         whereClauses: updatedWhereClauses,
//         recordLimit: updatedRecordLimit.recordLimit,
//         isDescending: !!updatedRecordLimit.isDescending,
//     };
// }
